import { render, staticRenderFns } from "./customMessage.vue?vue&type=template&id=613614f1&scoped=true"
import script from "./customMessage.vue?vue&type=script&lang=js"
export * from "./customMessage.vue?vue&type=script&lang=js"
import style0 from "./customMessage.vue?vue&type=style&index=0&id=613614f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613614f1",
  null
  
)

export default component.exports